"use strict"; // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var _possibleConstructorReturn = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _slicedToArray = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Dataset = require("../dataset");

var Expression = require("../expression");

var Prototypes = require("../prototypes");

var common_1 = require("../common");

var abstract_1 = require("./abstract");

var wasm_solver_1 = require("./wasm_solver");
/** Solves constraints in the scope of a chart */


var ChartConstraintSolver =
/*#__PURE__*/
function () {
  /** Create a ChartConstraintSolver
   * - stage == "chart": disregard glyphs, solve chart-level constraints
   * - stage == "glyphs": fix chart-level attributes, solve only glyphs
   * @param stage determines the scope of the variables to solve
   */
  function ChartConstraintSolver(stage) {
    _classCallCheck(this, ChartConstraintSolver);

    this.supportVariables = new common_1.KeyNameMap();
    this.glyphAnalyzeResults = new WeakMap();
    this.solver = new wasm_solver_1.WASMSolver();
    this.stage = stage;
  }

  _createClass(ChartConstraintSolver, [{
    key: "setManager",
    value: function setManager(manager) {
      this.chart = manager.chart;
      this.chartState = manager.chartState;
      this.manager = manager;
      this.dataset = manager.dataset;
      this.datasetContext = new Dataset.DatasetContext(this.dataset);
      this.expressionCache = new Expression.ExpressionCache();
    }
  }, {
    key: "setDataset",
    value: function setDataset(dataset) {
      this.dataset = dataset;
      this.datasetContext = new Dataset.DatasetContext(this.dataset);
      this.expressionCache = new Expression.ExpressionCache();
    }
  }, {
    key: "solve",
    value: function solve() {
      var loss = this.solver.solve();
      this.solver.applyPlugins();
      return {
        softLoss: loss[1],
        hardLoss: loss[0]
      };
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.solver) {
        this.solver.destroy();
      }
    }
  }, {
    key: "addMapping",
    value: function addMapping(attrs, parentAttrs, attr, info, mapping, rowContext) {
      if (rowContext == null && (mapping.type == "scale" || mapping.type == "text")) {
        var xMapping = mapping || mapping;
        rowContext = this.manager.getChartDataContext(xMapping.table);
      }

      switch (mapping.type) {
        case "scale":
          {
            var scaleMapping = mapping;

            if (scaleMapping.scale != null) {
              // Apply the scale
              var expr = this.expressionCache.parse(scaleMapping.expression);
              var dataValue = expr.getValue(rowContext);
              var scaleClass = this.manager.getClassById(scaleMapping.scale);

              if (!info.solverExclude) {
                scaleClass.buildConstraint(dataValue, this.solver.attr(attrs, attr), this.solver);
              }

              var value = scaleClass.mapDataToAttribute(dataValue);
              attrs[attr] = value; // this.registry.makeConstant(attrs, attr);
              // this.hardBuilder.addLinear(value as number, [[-1, this.hardBuilder.attr(attrs, attr)]])
            } else {
              // No scale, map the column value directly
              var _expr = this.expressionCache.parse(scaleMapping.expression);

              var _dataValue = _expr.getValue(rowContext);

              attrs[attr] = _dataValue;

              if (!info.solverExclude) {
                this.solver.makeConstant(attrs, attr);
              } // this.hardBuilder.addLinear(attrs[attr] as number, [[-1, this.hardBuilder.attr(attrs, attr)]])

            }
          }
          break;

        case "text":
          {
            var textMapping = mapping;

            var _expr2 = this.expressionCache.parseTextExpression(textMapping.textExpression);

            attrs[attr] = _expr2.getValue(rowContext);
          }
          break;

        case "value":
          {
            var valueMapping = mapping;
            attrs[attr] = valueMapping.value;

            if (!info.solverExclude) {
              this.solver.makeConstant(attrs, attr);
            } // this.registry.makeConstant(attrs, attr);

          }
          break;

        case "parent":
          {
            var parentMapping = mapping;
            this.solver.addEquals(abstract_1.ConstraintStrength.HARD, this.solver.attr(attrs, attr), this.solver.attr(parentAttrs, parentMapping.parentAttribute));
          }
          break;
      }
    }
  }, {
    key: "addObject",
    value: function addObject(object, objectState, parentState, rowContext, solve) {
      var objectClass = this.manager.getClass(objectState);
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = objectClass.attributeNames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var attr = _step.value;
          var info = objectClass.attributes[attr];

          if (!info.solverExclude) {
            if (objectState.attributes[attr] == null) {
              objectState.attributes[attr] = 0;
            }

            this.addAttribute(objectState.attributes, attr, solve || info.editableInGlyphStage);
          }

          if (!info.stateExclude) {
            if (object.mappings.hasOwnProperty(attr)) {
              // If the attribute is mapped, apply the mapping, and do not compute gradient
              var mapping = object.mappings[attr];
              this.addMapping(objectState.attributes, parentState != null ? parentState.attributes : null, attr, info, mapping, rowContext);
            } else {
              if (info.defaultValue !== undefined) {
                objectState.attributes[attr] = info.defaultValue;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "addScales",
    value: function addScales() {
      var allowScaleParameterChange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var chart = this.chart,
          chartState = this.chartState;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = common_1.zip(chart.scales, chartState.scales)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _ref3 = _step2.value;

          var _ref2 = _slicedToArray(_ref3, 2);

          var scale = _ref2[0];
          var scaleState = _ref2[1];
          this.addObject(scale, scaleState, null, null, allowScaleParameterChange);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  }, {
    key: "getSupportVariable",
    value: function getSupportVariable(key, name, defaultValue) {
      if (this.supportVariables.has(key, name)) {
        return this.solver.attr(this.supportVariables.get(key, name), "value");
      } else {
        var attr = {};
        attr.value = defaultValue;
        this.supportVariables.add(key, name, attr);
        var variable = this.solver.attr(attr, "value", {
          edit: true
        });
        return variable;
      }
    }
  }, {
    key: "addMark",
    value: function addMark(layout, mark, rowContext, markState, element, elementState) {
      var _this = this;

      this.addObject(element, elementState, markState, rowContext, true);
      var elementClass = this.manager.getMarkClass(elementState);
      elementClass.buildConstraints(this.solver, {
        rowContext: rowContext,
        getExpressionValue: function getExpressionValue(expr, context) {
          return _this.manager.dataflow.cache.parse(expr).getNumberValue(context);
        }
      });
    }
  }, {
    key: "getAttachedAttributes",
    value: function getAttachedAttributes(mark) {
      var attached = new Set();
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = mark.marks[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var element = _step3.value;

          if (element.classID == "mark.anchor") {
            continue;
          }

          for (var name in element.mappings) {
            var mapping = element.mappings[name];

            if (mapping.type == "parent") {
              attached.add(mapping.parentAttribute);
            }
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return attached;
    }
  }, {
    key: "getGlyphAnalyzeResult",
    value: function getGlyphAnalyzeResult(glyph) {
      if (this.glyphAnalyzeResults.has(glyph)) {
        return this.glyphAnalyzeResults.get(glyph);
      }

      var analyzer = new GlyphConstraintAnalyzer(glyph);
      analyzer.solve();
      this.glyphAnalyzeResults.set(glyph, analyzer);
      return analyzer;
    }
  }, {
    key: "addGlyph",
    value: function addGlyph(layout, rowContext, glyph, glyphState) {
      // Mark attributes
      this.addObject(glyph, glyphState, null, rowContext, true);
      var glyphAnalyzed = this.getGlyphAnalyzeResult(glyph);
      var glyphClass = this.manager.getGlyphClass(glyphState);
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = glyphClass.attributeNames[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var attr = _step4.value;

          // const info = glyphClass.attributes[attr];
          // if (info.solverExclude) {
          //   continue;
          // }
          // this.addAttribute(glyphState.attributes, attr, true);
          // If width/height are not constrained, make them constant
          if (attr == "width" && glyphAnalyzed.widthFree) {
            var variable = this.getSupportVariable(layout, glyph._id + "/" + attr, glyphState.attributes[attr]);
            this.solver.addEquals(abstract_1.ConstraintStrength.HARD, variable, this.solver.attr(glyphState.attributes, attr));
          }

          if (attr == "height" && glyphAnalyzed.heightFree) {
            var _variable = this.getSupportVariable(layout, glyph._id + "/" + attr, glyphState.attributes[attr]);

            this.solver.addEquals(abstract_1.ConstraintStrength.HARD, _variable, this.solver.attr(glyphState.attributes, attr));
          }
        } // Element attributes and intrinsic constraints

      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = common_1.zip(glyph.marks, glyphState.marks)[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var _ref6 = _step5.value;

          var _ref5 = _slicedToArray(_ref6, 2);

          var element = _ref5[0];
          var elementState = _ref5[1];
          this.addMark(layout, glyph, rowContext, glyphState, element, elementState);
        } // Mark-level constraints

      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      glyphClass.buildIntrinsicConstraints(this.solver);
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = glyph.constraints[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var constraint = _step6.value;
          var cls = Prototypes.Constraints.ConstraintTypeClass.getClass(constraint.type);
          cls.buildConstraints(constraint, glyph.marks, glyphState.marks, this.solver);
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }
    }
  }, {
    key: "addAttribute",
    value: function addAttribute(attrs, attr, edit) {
      this.solver.attr(attrs, attr, {
        edit: edit
      });
    }
  }, {
    key: "addChart",
    value: function addChart() {
      var _this2 = this;

      var chart = this.chart,
          chartState = this.chartState;
      this.addObject(chart, chartState, null, null, this.stage == "chart");
      var boundsClass = this.manager.getChartClass(chartState);
      boundsClass.buildIntrinsicConstraints(this.solver);
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = common_1.zip(chart.elements, chartState.elements)[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var _ref9 = _step7.value;

          var _ref8 = _slicedToArray(_ref9, 2);

          var element = _ref8[0];
          var elementState = _ref8[1];
          this.addObject(element, elementState, chartState, null, this.stage == "chart");
          var elementClass = this.manager.getChartElementClass(elementState);
          elementClass.buildConstraints(this.solver, {
            getExpressionValue: function getExpressionValue(expr, context) {
              return _this2.manager.dataflow.cache.parse(expr).getNumberValue(context);
            },
            getGlyphAttributes: function getGlyphAttributes(glyphID, table, rowIndex) {
              var analyzed = _this2.getGlyphAnalyzeResult(common_1.getById(_this2.chart.glyphs, glyphID));

              return analyzed.computeAttributes(_this2.manager.dataflow.getTable(table).getGroupedContext(rowIndex));
            }
          });

          if (this.stage == "glyphs") {
            if (Prototypes.isType(element.classID, "plot-segment")) {
              var layout = element;
              var layoutState = elementState;
              var mark = common_1.getById(chart.glyphs, layout.glyph);
              var tableContext = this.manager.dataflow.getTable(layout.table);
              var _iteratorNormalCompletion9 = true;
              var _didIteratorError9 = false;
              var _iteratorError9 = undefined;

              try {
                for (var _iterator9 = common_1.zip(layoutState.dataRowIndices, layoutState.glyphs)[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                  var _ref12 = _step9.value;

                  var _ref11 = _slicedToArray(_ref12, 2);

                  var dataRowIndex = _ref11[0];
                  var markState = _ref11[1];
                  this.addGlyph(layout, tableContext.getGroupedContext(dataRowIndex), mark, markState);
                }
              } catch (err) {
                _didIteratorError9 = true;
                _iteratorError9 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion9 && _iterator9.return != null) {
                    _iterator9.return();
                  }
                } finally {
                  if (_didIteratorError9) {
                    throw _iteratorError9;
                  }
                }
              }

              elementClass.buildGlyphConstraints(this.solver, {
                getExpressionValue: function getExpressionValue(expr, context) {
                  return _this2.manager.dataflow.cache.parse(expr).getNumberValue(context);
                },
                getGlyphAttributes: function getGlyphAttributes(glyphID, table, rowIndex) {
                  var analyzed = _this2.getGlyphAnalyzeResult(common_1.getById(_this2.chart.glyphs, glyphID));

                  return analyzed.computeAttributes(_this2.manager.dataflow.getTable(table).getGroupedContext(rowIndex));
                }
              });
            }
          }
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = chart.constraints[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var constraint = _step8.value;
          var cls = Prototypes.Constraints.ConstraintTypeClass.getClass(constraint.type);
          cls.buildConstraints(constraint, chart.elements, chartState.elements, this.solver);
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }
    }
  }, {
    key: "setup",
    value: function setup(manager) {
      this.setManager(manager);
      this.addScales(true);
      this.addChart();
    }
  }]);

  return ChartConstraintSolver;
}();

exports.ChartConstraintSolver = ChartConstraintSolver;

var GlyphConstraintAnalyzer =
/*#__PURE__*/
function (_abstract_1$Constrain) {
  _inherits(GlyphConstraintAnalyzer, _abstract_1$Constrain);

  function GlyphConstraintAnalyzer(glyph) {
    var _this3;

    _classCallCheck(this, GlyphConstraintAnalyzer);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(GlyphConstraintAnalyzer).call(this)); // Variable registry

    _this3.variableRegistry = new common_1.KeyNameMap();
    _this3.indexToAttribute = new Map();
    _this3.currentVariableIndex = 0;
    _this3.linears = [];
    _this3.inputBiases = new Map();
    _this3.indexToBias = new Map();
    _this3.inputBiasesCount = 0;
    _this3.dataInputList = new Map();
    var glyphState = {
      attributes: {},
      marks: []
    };
    var glyphClass = Prototypes.ObjectClasses.Create(null, glyph, glyphState);
    glyphClass.initializeState();
    var _iteratorNormalCompletion10 = true;
    var _didIteratorError10 = false;
    var _iteratorError10 = undefined;

    try {
      for (var _iterator10 = glyph.marks[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
        var mark = _step10.value;
        var markState = {
          attributes: {}
        };
        glyphState.marks.push(markState);
        var markClass = Prototypes.ObjectClasses.Create(glyphClass, mark, markState);
        markClass.initializeState();
      }
    } catch (err) {
      _didIteratorError10 = true;
      _iteratorError10 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion10 && _iterator10.return != null) {
          _iterator10.return();
        }
      } finally {
        if (_didIteratorError10) {
          throw _iteratorError10;
        }
      }
    }

    var _iteratorNormalCompletion11 = true;
    var _didIteratorError11 = false;
    var _iteratorError11 = undefined;

    try {
      for (var _iterator11 = glyphClass.attributeNames[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
        var attr = _step11.value;
        var info = glyphClass.attributes[attr];

        if (info.solverExclude) {
          continue;
        }

        _this3.addAttribute(glyphState.attributes, attr, glyph._id);

        if (glyph.mappings.hasOwnProperty(attr)) {
          _this3.addMapping(glyphState.attributes, attr, glyph.mappings[attr], null);
        }
      }
    } catch (err) {
      _didIteratorError11 = true;
      _iteratorError11 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion11 && _iterator11.return != null) {
          _iterator11.return();
        }
      } finally {
        if (_didIteratorError11) {
          throw _iteratorError11;
        }
      }
    }

    var _iteratorNormalCompletion12 = true;
    var _didIteratorError12 = false;
    var _iteratorError12 = undefined;

    try {
      for (var _iterator12 = common_1.zip(glyph.marks, glyphState.marks)[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
        var _ref15 = _step12.value;

        var _ref14 = _slicedToArray(_ref15, 2);

        var _mark = _ref14[0];
        var _markState = _ref14[1];

        var _markClass = Prototypes.ObjectClasses.Create(glyphClass, _mark, _markState);

        var _iteratorNormalCompletion14 = true;
        var _didIteratorError14 = false;
        var _iteratorError14 = undefined;

        try {
          for (var _iterator14 = _markClass.attributeNames[Symbol.iterator](), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
            var _attr2 = _step14.value;
            var _info = _markClass.attributes[_attr2];

            if (_info.solverExclude) {
              continue;
            }

            _this3.addAttribute(_markState.attributes, _attr2, _mark._id);

            if (_mark.mappings.hasOwnProperty(_attr2)) {
              _this3.addMapping(_markState.attributes, _attr2, _mark.mappings[_attr2], glyphState.attributes);
            }
          }
        } catch (err) {
          _didIteratorError14 = true;
          _iteratorError14 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion14 && _iterator14.return != null) {
              _iterator14.return();
            }
          } finally {
            if (_didIteratorError14) {
              throw _iteratorError14;
            }
          }
        }

        _markClass.buildConstraints(_assertThisInitialized(_this3), {
          getExpressionValue: function getExpressionValue() {
            return 1;
          }
        });
      }
    } catch (err) {
      _didIteratorError12 = true;
      _iteratorError12 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion12 && _iterator12.return != null) {
          _iterator12.return();
        }
      } finally {
        if (_didIteratorError12) {
          throw _iteratorError12;
        }
      }
    }

    glyphClass.buildIntrinsicConstraints(_assertThisInitialized(_this3));

    _this3.addInputAttribute("x", _this3.attr(glyphState.attributes, "x"));

    _this3.addInputAttribute("y", _this3.attr(glyphState.attributes, "y"));

    var _iteratorNormalCompletion13 = true;
    var _didIteratorError13 = false;
    var _iteratorError13 = undefined;

    try {
      for (var _iterator13 = glyph.constraints[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
        var constraint = _step13.value;
        var cls = Prototypes.Constraints.ConstraintTypeClass.getClass(constraint.type);
        cls.buildConstraints(constraint, glyph.marks, glyphState.marks, _assertThisInitialized(_this3));
      }
    } catch (err) {
      _didIteratorError13 = true;
      _iteratorError13 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion13 && _iterator13.return != null) {
          _iterator13.return();
        }
      } finally {
        if (_didIteratorError13) {
          throw _iteratorError13;
        }
      }
    }

    _this3.glyphState = glyphState;
    return _this3;
  }

  _createClass(GlyphConstraintAnalyzer, [{
    key: "addAttribute",
    value: function addAttribute(attrs, attr, id) {
      var value = this.currentVariableIndex;
      var attrInfo = {
        index: this.currentVariableIndex,
        type: "object",
        id: id,
        attribute: attr
      };
      this.variableRegistry.add(attrs, attr, attrInfo);
      this.indexToAttribute.set(attrInfo.index, attrInfo);
      this.currentVariableIndex += 1;
      return attrInfo;
    } // Allocate or get attribute index

  }, {
    key: "attr",
    value: function attr(attrs, _attr) {
      if (this.variableRegistry.has(attrs, _attr)) {
        return this.variableRegistry.get(attrs, _attr);
      } else {
        var value = this.currentVariableIndex;
        var attrInfo = {
          index: this.currentVariableIndex,
          id: common_1.uniqueID(),
          type: "object",
          attribute: _attr
        };
        console.warn("Adding unnamed attribute", _attr);
        this.variableRegistry.add(attrs, _attr, attrInfo);
        this.indexToAttribute.set(attrInfo.index, attrInfo);
        this.currentVariableIndex += 1;
        return attrInfo;
      }
    }
  }, {
    key: "addLinear",
    value: function addLinear(strength, bias, lhs) {
      var rhs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
      this.linears.push([bias, lhs.map(function (_ref16) {
        var _ref17 = _slicedToArray(_ref16, 2),
            weight = _ref17[0],
            obj = _ref17[1];

        return {
          weight: weight,
          index: obj.index
        };
      }).concat(rhs.map(function (_ref18) {
        var _ref19 = _slicedToArray(_ref18, 2),
            weight = _ref19[0],
            obj = _ref19[1];

        return {
          weight: -weight,
          index: obj.index
        };
      }))]);
    }
  }, {
    key: "addSoftInequality",
    value: function addSoftInequality(strength, bias, lhs) {
      var rhs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
      this.linears.push([bias, lhs.map(function (_ref20) {
        var _ref21 = _slicedToArray(_ref20, 2),
            weight = _ref21[0],
            obj = _ref21[1];

        return {
          weight: weight,
          index: obj.index
        };
      }).concat(rhs.map(function (_ref22) {
        var _ref23 = _slicedToArray(_ref22, 2),
            weight = _ref23[0],
            obj = _ref23[1];

        return {
          weight: -weight,
          index: obj.index
        };
      }))]);
    }
  }, {
    key: "addInputAttribute",
    value: function addInputAttribute(name, attr) {
      if (this.inputBiases.has(name)) {
        var idx = this.inputBiases.get(name).index;
        this.linears.push([0, [{
          weight: 1,
          index: attr.index
        }, {
          weight: 1,
          biasIndex: idx
        }]]);
      } else {
        var _idx = this.inputBiasesCount;
        this.inputBiasesCount++;
        var attrInfo = {
          index: _idx,
          type: "input",
          id: null,
          attribute: name
        };
        this.inputBiases.set(name, attrInfo);
        this.indexToBias.set(attrInfo.index, attrInfo);
        this.linears.push([0, [{
          weight: 1,
          index: attr.index
        }, {
          weight: 1,
          biasIndex: _idx
        }]]);
      }
    }
  }, {
    key: "addDataInput",
    value: function addDataInput(name, expression) {
      this.dataInputList.set(name, Expression.parse(expression));
    }
  }, {
    key: "addMapping",
    value: function addMapping(attrs, attr, mapping, parentAttrs) {
      switch (mapping.type) {
        case "scale":
          {
            var scaleMapping = mapping;
            this.addInputAttribute("scale/".concat(scaleMapping.scale, "/").concat(scaleMapping.expression), this.attr(attrs, attr));
            this.addDataInput("scale/".concat(scaleMapping.scale, "/").concat(scaleMapping.expression), scaleMapping.expression);
          }
          break;

        case "value":
          {
            var valueMapping = mapping;
            attrs[attr] = valueMapping.value;
            this.addLinear(abstract_1.ConstraintStrength.HARD, valueMapping.value, [[-1, this.attr(attrs, attr)]]);
          }
          break;

        case "parent":
          {
            var parentMapping = mapping;
            this.addEquals(abstract_1.ConstraintStrength.HARD, this.attr(attrs, attr), this.attr(parentAttrs, parentMapping.parentAttribute));
          }
          break;
      }
    }
  }, {
    key: "setValue",
    value: function setValue() {}
  }, {
    key: "getValue",
    value: function getValue() {
      return 0;
    }
  }, {
    key: "makeConstant",
    value: function makeConstant(attr) {
      console.warn("(unimplemented) Make Constant: ", attr);
    }
  }, {
    key: "destroy",
    value: function destroy() {}
  }, {
    key: "solve",
    value: function solve() {
      var N = this.currentVariableIndex;
      var linears = this.linears; // Formulate the problem as A * X = B

      var A = new wasm_solver_1.Matrix();
      A.init(linears.length, N);
      var B = new wasm_solver_1.Matrix();
      B.init(linears.length, this.inputBiasesCount + 1);
      var A_data = A.data(),
          A_rowStride = A.rowStride,
          A_colStride = A.colStride;
      var B_data = B.data(),
          B_rowStride = B.rowStride,
          B_colStride = B.colStride;

      for (var i = 0; i < linears.length; i++) {
        B_data[i * B_rowStride] = -linears[i][0];
        var _iteratorNormalCompletion15 = true;
        var _didIteratorError15 = false;
        var _iteratorError15 = undefined;

        try {
          for (var _iterator15 = linears[i][1][Symbol.iterator](), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
            var item = _step15.value;

            if (item.index != null) {
              A_data[i * A_rowStride + item.index * A_colStride] = item.weight;
            }

            if (item.biasIndex != null) {
              B_data[i * B_rowStride + (1 + item.biasIndex) * B_colStride] = item.weight;
            }
          }
        } catch (err) {
          _didIteratorError15 = true;
          _iteratorError15 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion15 && _iterator15.return != null) {
              _iterator15.return();
            }
          } finally {
            if (_didIteratorError15) {
              throw _iteratorError15;
            }
          }
        }
      }

      var X = new wasm_solver_1.Matrix();
      var ker = new wasm_solver_1.Matrix();
      wasm_solver_1.Matrix.SolveLinearSystem(X, ker, A, B);
      this.X0 = [];
      this.ker = [];
      var X_data = X.data(),
          X_colStride = X.colStride,
          X_rowStride = X.rowStride;

      for (var _i = 0; _i < X.cols; _i++) {
        var a = new Float64Array(N);

        for (var j = 0; j < N; j++) {
          a[j] = X_data[_i * X_colStride + j * X_rowStride];
        }

        this.X0.push(a);
      }

      var ker_data = ker.data(),
          ker_colStride = ker.colStride,
          ker_rowStride = ker.rowStride;

      for (var _i2 = 0; _i2 < ker.cols; _i2++) {
        var _a = new Float64Array(N);

        for (var _j = 0; _j < N; _j++) {
          _a[_j] = ker_data[_i2 * ker_colStride + _j * ker_rowStride];
        }

        this.ker.push(_a);
      }

      X.destroy();
      ker.destroy();
      A.destroy();
      B.destroy();
      return null;
    }
  }, {
    key: "isAttributeFree",
    value: function isAttributeFree(attr) {
      var isNonZero = false;
      var _iteratorNormalCompletion16 = true;
      var _didIteratorError16 = false;
      var _iteratorError16 = undefined;

      try {
        for (var _iterator16 = this.ker[Symbol.iterator](), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
          var x = _step16.value;

          if (Math.abs(x[attr.index]) > 1e-8) {
            isNonZero = true;
          }
        }
      } catch (err) {
        _didIteratorError16 = true;
        _iteratorError16 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion16 && _iterator16.return != null) {
            _iterator16.return();
          }
        } finally {
          if (_didIteratorError16) {
            throw _iteratorError16;
          }
        }
      }

      return isNonZero;
    }
  }, {
    key: "computeAttribute",
    value: function computeAttribute(attr, rowContext) {
      var result = 0;

      for (var i = 0; i < this.X0.length; i++) {
        var bi = this.X0[i][attr.index];

        if (i == 0) {
          result += bi;
        } else {
          var bias = this.indexToBias.get(i - 1);

          if (bias && this.dataInputList.has(bias.attribute)) {
            result += bi * this.dataInputList.get(bias.attribute).getNumberValue(rowContext);
          }
        }
      }

      return result;
    }
  }, {
    key: "computeAttributes",
    value: function computeAttributes(rowContext) {
      return {
        width: this.computeAttribute(this.attr(this.glyphState.attributes, "width"), rowContext),
        height: this.computeAttribute(this.attr(this.glyphState.attributes, "height"), rowContext)
      };
    }
  }, {
    key: "widthFree",
    get: function get() {
      return this.isAttributeFree(this.attr(this.glyphState.attributes, "width"));
    }
  }, {
    key: "heightFree",
    get: function get() {
      return this.isAttributeFree(this.attr(this.glyphState.attributes, "height"));
    }
  }]);

  return GlyphConstraintAnalyzer;
}(abstract_1.ConstraintSolver);

exports.GlyphConstraintAnalyzer = GlyphConstraintAnalyzer;